/**
 * UX module
 * -- Uncomment functions as they are needed --
 */
mmf_modules.define('utils/ux',[
    'underscore',
    'jquery',
    'handlebars',
    'plugins/ui',
    'plugins/qtip',
    'plugins/royalSlider',
    'plugins/jquery.migrate',
    'utils/storage',
    'utils/user',
    'utils/utils',
    'utils/urls',
    'utils/ensure_dataLayer',
    'hbs!tmpl/utils/modal_messager',

    'templates/helpers/eq'
], function (
    _,
    $,
    Handlebars,
    ui_is_jq_plugin,
    qtip_is_jq_plugin,
    royalSlider_is_jq_plugin,
    migrate_is_jq_plugin,
    Storage,
    User,
    utils,
    mmf_urls,
    dataLayer,
    modalMessagerTmpl,

    eq
) {
    'use strict';

    var UX = {};

    UX.Tooltip = {
        /**
         * Initializes tooltips on elemenents matching the provided selector. Sets default system settings for qtip
         * and provides for overriding of options.
         */
        Init: function (selector, options) {
            utils.assert(selector);

            var tips = [];
            options = options || {};

            $(selector).each(function () {
                var $e = $(this),
                    default_classes = 'qtip-light',
                    show = 'click',
                    hide = 'click',
                    my_position = 'top center',
                    at_position = 'bottom center',
                    settings = $.extend({}, $e.data(), options),
                    style,
                    target,
                    content;

                if (settings.style && typeof settings.style === 'object') {
                    style = settings.style;
                }
                else {
                    style = {
                        classes: settings.style || default_classes +
                            ' qtip-shadow qtip-rounded',
                        tip: {
                            width: 10,
                            height: 10
                        },
                        height: settings.height,
                        width: settings.width
                    };
                }
                if (settings.tooltipEvent === 'mouseover') {
                    show = 'mouseover';
                    hide = 'mouseout';
                }

                if (settings.my_position) {
                    my_position = settings.my_position;
                }
                if (settings.at_position) {
                    at_position = settings.at_position;
                }
                else if (settings.position === 'right') {
                    my_position = 'left center';
                    at_position = 'right center';
                }
                else if (settings.position === 'top') {
                    my_position = 'bottom center';
                    at_position = 'top center';
                }
                else if (settings.position === 'left') {
                    my_position = 'right center';
                    at_position = 'left center';
                }

                // content
                if (settings.content || settings.contentId) {
                    if (settings.contentId) {
                        content = $('#' + settings.contentId).html();
                    }
                    else if (settings.content) {
                        content = settings.content;
                    }
                } else {
                    content = $e.next('.tooltip_content').html();
                }

                if ($e) {
                    $e.qtip($.extend({}, {
                        content: content,
                        style: style,
                        position: typeof (settings.position) === 'object' ?
                            settings.position : {
                            my: my_position,
                            at: at_position,
                            target: target || settings.target || false
                        },
                        show: settings.show || show,
                        hide: settings.hide || hide,
                        events: settings.events
                    })).click(function (event) {
                        if (settings.tooltipEvent !== 'mouseover') {
                            event.preventDefault();
                        }
                    });
                }

                tips.push({
                    destroy: function () {
                        UX.Tooltip.Destroy($e);
                    },
                    refresh: function () {
                        UX.Tooltip.Refresh($e, options);
                    }
                });
            });

            return tips;
        },

        Refresh: function (selector, options) {
            UX.Tooltip.Destroy(selector);
            UX.Tooltip.Init(selector, options);
        },

        Destroy: function (selector) {
            $(selector).qtip('destroy');
        }
    };

    // UX Header Specific
    UX.Header = {};

    // align the sub nav menu items to the middle of their parent
    UX.Header.SubNav = {
        Init: function () {
            $('.sub_section').each(function () {
                var self = $(this),
                    content = self.find('.content');

                // For internationalization,  change the width of our submenu
                // based on it's contents width (since the width will changed based on language)
                content.each(function () {
                    var content_width = 0,
                        $self = $(this);
                    if ($self.children('ul').length >= 1) {
                        $self.children('ul').each(function (i, e) {
                            var $this = $(this),
                                submenu_container = $this.parents('.sub_section');

                            // grab the width of the content without showing the submenu
                            submenu_container.css({
                                position: 'absolute',
                                visibility: 'hidden',
                                display: 'block'
                            });
                            var trueWidth = $this.width();

                            submenu_container.css({
                                position: '',
                                visibility: '',
                                display: 'none'
                            });
                            content_width += trueWidth;
                        });
                        $self.width(content_width + 30);
                    }
                });

                // posiiton our arrow to the middle of the submenu after internationalization width is found.
                var main_menu_middle = self.parent().width() / 2,
                    submenu_middle = self.width() / 2,
                    submenu_left_position = main_menu_middle - submenu_middle;
                self.css('left', submenu_left_position);
                self.hover(function () {
                    self.parent().find('a.main').addClass('active');
                }, function () {
                    self.parent().find('a.main').removeClass('active');
                });

            });

            $('.nav_list li.main, .user_info_selector').each(function (e) {
                var elm = $(this),
                    subnav = $('#' + elm.children('a').attr('data-nav') + '_subnav');

                if (elm.attr('data-nav') === 'settings') {
                    subnav = $('#' + elm.attr('data-nav') + '_subnav');
                }

                elm.hover(function () {
                    var timeout = $(this).data('timeout');
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    subnav.show();
                }, function () {
                    $(this).data('timeout', setTimeout($.proxy(function () {
                        subnav.hide();
                    }, this), 1));
                });
            });
        }
    };


    // UX Header Search
    UX.Header.Search = {
        Init: function () {
            $('#search_site_selector').each(function (e) {
                var elm = $(this),
                    subnav = $('#site_search');

                elm.hover(function () {
                    var timeout = $(this).data('timeout');
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    subnav.show();
                    $('#q').focus();
                }, function () {
                    $(this).data('timeout', setTimeout($.proxy(function () {
                        subnav.hide();
                    }, this), 1));
                });
            });
        }
    };


    // UX Footer Specific
    UX.Footer = {};

    UX.Footer.Slider = {
        Init: function () {
            var self = $('.current_language');
            self.click(function (e) {
                e.preventDefault();
                $('#language_selection').slideToggle(200);
                $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                self.toggleClass('language_is_hidden');
            });
        }
    };

    UX.Tabs = {
        Init: function () {
            $('ul.tabs').each(function (i, e) {
                $(this).find('> li > a').click(function (event) {
                    var $tab = $(this);
                    // Get Location of tab's content
                    var contentLocation = $tab.attr('href');

                    // Let go if not a hashed one
                    if (contentLocation.charAt(0) === '#') {
                        e.preventDefault();

                        // Leave if disabled tab
                        if ($tab.hasClass('disabled')) {
                            return;
                        }

                        // Make Tab Active
                        $tab.removeClass('active');
                        $tab.addClass('active');

                        // Show Tab Content & add active class
                        $(contentLocation)
                            .show()
                            .addClass('active')
                            .siblings()
                            .hide()
                            .removeClass('active');
                    }
                });
            });
        }
    };

    /**
    * Opens a modal MVP tout
    * OPTIONAL:
    * @param {Number} params.auto_close_delay: Number of MS after which to close automatically
    * @param {String} params.text: Body text
    * @param {String} params.title: Body title
    */
    UX.ShowMvpTout = function showMvpTout (parms) {
       parms = parms || {};
       var auto_close_delay = parms.auto_close_delay || 0;
       var text = parms.text || 'When you upgrade to an MVP membership you gain access to a number of great tools ' +
            'that can help you achieve your goals.';
       var $content = $('<div>')
           .attr({
               title: 'MVP subscription is required for this feature.'
           })
           .on('click', function (event) {
               event.stopPropagation();
               window.location = mmf_urls.mvp_link;
           })
           .css({
               'cursor': 'pointer'
           })
           .append(
               $('<span>')
                   .attr({
                       id: 'mvp_upsell_close'
                   })
                   .html('&#215;')
                   .on('click', function (e) {
                       e.stopPropagation();
                       $(window).qtip().hide();
                   }),
               $('<img>')
                   .attr({
                       'alt': 'MVP Upgrade Tout',
                       'display': 'block',
                       'src': mmf_urls.mvp_image,
                       'title': 'Go MVP!'
                   }),
               $('<div>')
                   .css({
                       'height': '100px',
                       'left': '3%',
                       'margin': '0px',
                       'position': 'absolute',
                       'top': '94px',
                       'width': '94%'
                   })
                   .append(
                       $('<p>')
                           .css({
                               'color': '#999',
                               'margin': '30px 0px 0px',
                               'text-align': 'center',
                               'font-size': '13px',
                               'line-height': '1.5em'
                           })
                           .html(text),
                       $('<div class="mvp_upsell_container"><div class="button"><span>Learn More</span></div></div>')
                   )
           );

        $(window).qtip({
            content: {
                text: $content,
                title: false
            },
            position: {
                my: 'center', // ...at the center of the viewport
                at: 'center',
                target: $(window)
            },
            show: {
                event: false,
                effect: function () {
                    $(this).show();
                    $(this).find('.qtip-content').css({
                        'background': 'none',
                        'border': 'none',
                        'margin': 0,
                        'padding': 0,
                        'text-align': 'center',
                        'width': '100%'
                    });
                },
                ready: true,
                // solo hides all other tooltips
                solo: true,
                modal: true
            },
            hide: {
                event: false,
                delay: auto_close_delay,
                inactive: auto_close_delay || false
            },
            style: {
                'classes': 'qtip-light qtip-rounded largetip qtip-custom-clear',
                'height': '267px',
                'width': '458px',
                'background': 'none',
                'border': 0
            }
        });
    };

    UX.Responsive = {};

    var mobile_max_width = 768; // in pixels

    // generate a matchMedia object to detect if the client is mobile
    //      (based on screen size)
    // this matchMedia object supports a subset of the matchMedia API
    // (currently, just the `matches` property)
    var mobile_matchMedia = (window.matchMedia ?
        // use HTML5 media query if supported
        window.matchMedia('(max-width: ' + mobile_max_width + 'px)') :
        // otherwise, assume the client is not mobile
        // generate a pseudo-matchMedia object
        {
            matches: false
        }
    );

    // detect if client is mobile, based on useragent or screen width mediaquery
    // :returns: `true` if client can be considered 'mobile'
    // :rtype: boolean
    UX.Responsive.IsMobile = function () {
        var ua = (navigator.userAgent || navigator.vendor || window.opera);
        return ( // ginormous user-agent test blob from detectmobilebrowsers.com
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4))
            ) || mobile_matchMedia.matches;
    };

    UX.DocumentClose = function () {
        $(document).on('click', function () {
            $('.doc_close').hide();
            $('.tooltip').qtip('hide');

            // Special case for search site
            $('#search_site_selector').removeClass('active');
        });
    };

    UX.HoverContent = function () {
        $('.hover_content').each(function () {
            var e = $(this);

            e.hide();

            $(this).parent('.item').hover(function () {
                e.show();
            });
        });
    };

    UX.Favorite = function () {
        $('.favorite_icon').on('click', function (e) {
            var elm = $(this);

            if (elm.hasClass('active')) {
                elm.removeClass('active');
            } else {
                elm.addClass('active');
            }

            e.stopPropagation();
        });
    };

    UX.Touts = {
        Init: function () {
            $('.tout_item').each(function () {
                // Get the tout ID
                var elm = $(this),
                    tout_id = elm.attr('id'),
                    closeable = elm.hasClass('closeable');

                $('#' + tout_id + ' div a.button').on('click', function (e) {
                    e.preventDefault();
                    UX.Touts.TrackClick(tout_id);
                    window.location = $(this).attr('href');
                });

                if (!closeable) {
                    $(elm).show();
                    UX.Touts.TrackView(tout_id);
                    return false;
                }

                if (Storage.Get(tout_id) !== 'hide') {
                    $(elm).show();
                    UX.Touts.TrackView(tout_id);
                } else {
                    $(elm).remove();
                }

                $('#' + tout_id + ' div a.close_tout').on('click', function (e) {
                    e.preventDefault();

                    UX.Touts.TrackClose(tout_id);

                    Storage.Set(tout_id, 'hide');
                    elm.fadeOut();
                });
            });
        },
        TrackView: function (tout_id) {
            dataLayer.push({
                'event': 'classic event',
                'category': 'Touts',
                'action': tout_id,
                'label': 'Impression',
                'opt_value': 1
            });
        },
        TrackClose: function (tout_id) {
            dataLayer.push({
                'event': 'classic event',
                'category': 'Touts',
                'action': tout_id,
                'label': 'Close',
                'opt_value': 1
            });
        },
        TrackClick: function (tout_id) {
            dataLayer.push({
                'event': 'classic event',
                'category': 'Touts',
                'action': tout_id,
                'label': 'Click',
                'opt_value': 1
            });
        }
    };

    UX.List3 = function () {

        function show (elm) {
            elm.addClass('visible');
            elm.css('overflow', 'visible');
            elm.height('auto');
        }

        function hide (elm, height) {
            elm.removeClass('visible');
            elm.css('overflow', 'hidden');
            UX.ScrollTo(elm);
            elm.height(height);
        }

        $('.constrain').each(function () {
            var elm = $(this),
                height = elm.height();

            elm.parent().find('.constrain_toggle').on('click', function (e) {
                e.preventDefault();
                if (elm.hasClass('visible')) {
                    hide(elm, height);
                    $(this).text('Show All');
                } else {
                    show(elm);
                    $(this).text('Minimize');
                }
            });
        });
    };

    UX.Slider = function () {
        // Sliding Doors Function
        $(function () {
            $('.box_container').hover(function () {
                var distance = $(this).outerWidth();
                $(this).find('.box_image').animate({ left: distance }, {queue: false, duration: 300});
            }, function () {
                $(this).find('.box_image').animate({ left: '0px' }, {queue: false, duration: 300});
            });
        });

        // Royal Slider
        $('.list1Slider').each(function () {

            // If we are on small screens lets hide extra content
            // TODO - Need a better responsive solution for these.
            if (UX.Responsive.IsMobile()) {
                $(this).parent('div.box').css('overflow', 'hidden');
            }

            var w = $(this).attr('data-width'),
                h = $(this).attr('data-height');

            if (!w) {
                w = 610;
            }
            if (!h) {
                h = 140;
            }

            if (!$(this).hasClass('loaded')) {

                $(this).royalSlider({
                    imageAlignCenter: true,
                    imageScaleMode: 'fill',
                    hideArrowOnLastSlide: true,
                    slideSpacing: 20,
                    autoScaleSlider: true,
                    autoScaleSliderWidth: w,
                    autoScaleSliderHeight: h
                });
                $(this).addClass('loaded');
            }
        });
    };


    // For dynamically binding and loading ajax content
    // Example: <a href="#" class="ajax_load" data-ajax-url="${url('quickadd_workout')}" data-container="log_workout" data-container-class="quick_log_content">
    // Example: <div id="log_workout" class="quick_log_content"></div>
    UX.AjaxContainers = {
        Init: function () {
            $('.ajax_load').each(function () {
                var elm = $(this),
                    url = elm.attr('data-ajax-url'),
                    container = $('#' + elm.attr('data-container')),
                    container_class = elm.attr('data-container-class');

                $('.' + container_class).hide();

                elm.on('click', function (e) {
                    e.preventDefault();

                    if (!container.hasClass('loaded')) {
                        $.get(url, function (data) {
                            container.html(data);
                            container.addClass('loaded');
                            $('.' + container_class).hide();
                            container.slideDown();

                        });
                    } else {
                        $('.' + container_class).hide();
                        container.slideDown();
                    }

                    elm.parent('.ajax_load_toggle').parent('div').children('.ajax_load_toggle').removeClass('active');
                    elm.parent('.ajax_load_toggle').addClass('active');
                });
            });
        }
    };

    UX.Dialog = {
        Init: function () {
            $('.dialog').each(function () {

                var elm = $(this),
                    content = elm.next('div.dialog_content'),
                    modal = true,
                    title = '';

                if (elm.attr('data-dialog-modal') === 'false') {
                    modal = false;
                }
                if (elm.attr('data-dialog-title')) {
                    title = elm.attr('data-dialog-title');
                }

                content.dialog({
                    autoOpen: false,
                    show: 'clip',
                    hide: 'clip',
                    modal: modal,
                    title: title
                });

                elm.click(function () {
                    content.dialog('open');
                    return false;
                });
            });

            UX.Dialog.OverlayClose();
        },

        Invoke: function (elm, title, options) {
            options = options || {};
            var dialog_options = $.extend({}, {
                autoOpen: true,
                show: 'clip',
                hide: 'clip',
                modal: true,
                title: title
            }, options);
            $('#' + elm).dialog(dialog_options);
        },

        Close: function () {
            $('.ui-dialog-content').dialog('close');
        },

        OverlayClose: function () {
            $('body').on('click', '.ui-widget-overlay', function () {
                $('.ui-dialog-titlebar-close').trigger('click');
            });
        }
    };

    UX.QTipModal = function (element, title, content, useropts) {
       useropts = useropts || {};

       var opts = {
               ok: (typeof useropts.ok === 'undefined') ? true : useropts.ok,
               close: (typeof useropts.close === 'undefined') ? true : useropts.close,
               autoopen: (typeof useropts.autoopen === 'undefined') ? true : useropts.autoopen
           },

           el = $(element).qtip({
               content: {
                   text: $('<div>')
                       .css({
                           'padding': '1em'
                       })
                       .html(content),
                   title: {
                       button: 'Close',
                       text: title
                   }
               },
               events: {
                   show: function (event, api) {
                       if (opts.ok) {
                           $('<div class="qtip-content-footer"><button class="button">Ok</button></div>')
                               .appendTo('.qtip-content')
                               .find('button').on('click', function () {
                                   $(element).qtip('api').destroy();
                               });
                       }
                   }
               },
               hide: {
                   event: false
               },
               position: {
                   my: 'center',
                   at: 'center',
                   target: $(window)
               },
               show: {
                   modal: true,
                   solo: true,
                   event: false
               },
               style: {
                   'classes': 'qtip-light largetip',
                   'padding': '1em'
               }
           });

       if (opts.autoopen) {
           el.qtip('api').show();
       }

       return {
           destroy: function () {
               el.qtip('destroy');
           }
       };
    };

    UX.QTipConfirm = {
        dialogue: function (content, title) {
            /*
             * Since the dialogue isn't really a tooltip as such, we'll use a dummy
             * out-of-DOM element as our target instead of an actual element like document.body
             */
            $('<div />').qtip({
                content: {
                    text: content,
                    title: title
                },
                position: {
                    my: 'center',
                    at: 'center', // Center it...
                    target: $(window) // ... in the window
                },
                show: {
                    ready: true, // Show it straight away
                    modal: {
                        on: true, // Make it modal (darken the rest of the page)...
                        blur: false // ... but don't close the tooltip when clicked
                    }
                },
                hide: false, // We'll hide it maunally so disable hide events
                style: 'qtip-light qtip-dialogue qtip-confirm', // Add a few styles
                events: {
                    // Hide the tooltip when any buttons in the dialogue are clicked
                    render: function (event, api) {
                        $('button', api.elements.content).click($.proxy(api.hide, api));
                    },
                    // Destroy the tooltip once it's hidden as we no longer need it!
                    hide: function (event, api) { api.destroy(); }
                }
            });
        },

        // Our Confirm method
        Confirm: function (question, callback) {
            // Content will consist of the question and ok/cancel buttons
            var message = $('<span />', { text: '' }),
                ok = $('<button />', {
                    text: 'Ok',
                    'class': 'cta',
                    click: function () { callback(true); }
                }),
                cancel = $('<button />', {
                    text: 'Cancel',
                    click: function () { callback(false); }
                });

            UX.QTipConfirm.dialogue( message.add(ok).add(cancel), question );
        }
    };

    UX.QTipDialog = {
        Init: function () {
            $('.qtip_dialog').each(function () {
                var elm = $(this),
                    content,
                    classes = 'qtip-light largetip ',
                    modal = true,
                    button = true,
                    width = 600,
                    title = ' ',
                    auto_open = false; // If we don't at least have one character here the close button won't show

                if (elm.data('dialog-content')) {
                    content = $(elm.data('dialog-content'));
                } else {
                    content = elm.next('div.qtip_dialog_content');
                }

                if (elm.data('dialog-modal') !== undefined) {
                    modal = elm.data('dialog-modal');
                }
                if (elm.data('dialog-title')) {
                    title = elm.data('dialog-title');
                }
                if (elm.data('dialog-close-button') !== undefined) {
                    button = elm.data('dialog-close-button');
                }
                if (elm.data('dialog-width')) {
                    width = elm.data('dialog-width');
                }
                if (elm.data('dialog-classes')) {
                    classes += elm.data('dialog-classes');
                }
                if (elm.data('dialog_content')) {
                    content = $('#' + String(elm.data('dialog_content')));
                }
                if (elm.data('auto-open')) {
                    auto_open = true;
                }

                elm.qtip({
                    content: {
                        text: content.html(),
                        title: {
                            text: title,
                            button: button
                        }
                    },
                    position: {
                        my: 'center', // ...at the center of the viewport
                        at: 'center',
                        target: $(window)
                    },
                    show: {
                        event: 'click', // Show it on click...
                        solo: true, // ...and hide all other tooltips...
                        modal: modal, // ...and make it modal
                        ready: auto_open
                    },
                    hide: false,
                    style: {
                        classes: classes,
                        width: width
                    },
                    events: {
                        show: function () {
                            elm.trigger.apply(elm, ['qtip-show'].concat(arguments));
                        },
                        render: function () {
                            elm.trigger.apply(elm, ['qtip-render'].concat(arguments));
                        },
                        hide: function () {
                            elm.trigger.apply(elm, ['qtip-hide'].concat(arguments));
                        }
                    }
                });


                elm.on('click', function (event) {
                    event.preventDefault();
                });
            });
        },

        Invoke: function (elm, title) {

            $('#' + elm).dialog({
                autoOpen: true,
                show: 'clip',
                hide: 'clip',
                modal: true,
                title: title
            });
        },

        Close: function () {
            $('.qtip.ui-tooltip').qtip('hide');
        }
    };

    UX.TableOptions = function () {
        $('.table_options').each(function () {
            var elm = $(this);

            elm.closest('tr').on('hover', function () {

                if (elm.hasClass('visible')) {
                    elm.hide();
                    elm.removeClass('visible');
                } else {
                    $('.tooltip').qtip('hide');
                    elm.show();
                    elm.addClass('visible');
                }
            });
        });
    };

    UX.InlineEdit = function () {
        $('.editable').each(function () {
            var elm = $(this),
                save_url = elm.attr('data-url'),
                post_param = elm.attr('data-attribute'),
                edit_attr = elm.attr('data-editlink');

            // check to see if an instance of inlineEdit already exists on the element. It was found that
            // the inlineEdit plugin is not smart enough handle this and causes an error where on canceling an
            // active edit the value of the input is set to itself
            if (elm.data('value.inlineedit')) {
                return;
            }

            if (edit_attr) {
                var edit_link = $('#' + edit_attr);

                edit_link.on('click', function () {
                    var parent = elm.parent();
                    parent.find('.editable').trigger('click');
                });
            }

            elm.inlineEdit({
                hover: '',
                save: function (e, data) {
                    var parent = elm.parent();
                    var cleanData;
                    try {
                      // this block does not make much sense, because
                      // it seems as data.value is always value of <input>,
                      // but it is preserved here to make sure it does not
                      // break inlineEdit somewhere
                      cleanData = $(data.value).text();
                    } catch (e) {}
                    cleanData = cleanData || data.value;

                    $('.editable.edit-in-progress').text(cleanData);
                    parent.find('.editable').find('input').val(cleanData);
                    var form_data = {};
                    form_data[post_param] = cleanData;
                    $.ajax({
                        url: save_url,
                        data: form_data,
                        type: 'POST',
                        success: function (data) {

                        },
                        error: function () {

                        }
                    });
                },
                maxLength: elm.data('max-length') || null
            });
        });
    };

    UX.Messaging = {
        // Used with django contrib messaging system, template in base/web/base.html
        Init: function () {
            var message_num = 0;
            $('.internal_message').each(function () {
                var elm = $(this),
                    autohide = true,
                    msg = elm.html();

                if (elm.attr('data-autohide')) {
                    autohide = elm.attr('data-autohide');
                }
                UX.Messaging.View(msg, autohide, message_num);
                message_num += 1;
            });
        },
        View: function (msg, autohide, message_num) {
            var messages = message_num || 0,
                $note = $('<div></div>');

            $note
                .addClass('note_bottom')
                .html(msg);

            if (autohide) {
                $note
                    .delay(900 + 9400 * messages)
                    .hide()
                    .prependTo('body')
                    .slideDown('slow')
                    .delay(8500 + 9400 * messages)
                    .slideUp('slow');
            } else {
                $note
                    .delay(900)
                    .hide()
                    .prependTo('body')
                    .slideDown('slow');
                // Add a close button and bind
            }
        }
    };

    UX.JumpMenu = {
        Init: function () {
            $('.jump_menu').each(function () {
                var item = $(this);

                item.on('change', function () {
                    var url = $(this).attr('selected', true).val();

                    window.location = url;
                });
            });
        }
    };

    UX.SubmitOnce = {
        init: function () {
            if (UX.SubmitOnce.initialized) {
                return;
            }
            $('[data-submission_style=once]').each(function () {
                var $elem = $(this);
                $elem.on('click', function (e) {
                    if ($elem.data('submitted_state') === true) {
                        e.preventDefault();
                    } else {
                        $elem.data('submitted_state', true);
                    }
                });
            });
        },
        initialized: false
    };

    UX.Expandable = {
        Init: function () {
            $('.expandable').each(function () {
                var $trigger = $(this).children('a');
                var container_id = $(this).data('expand-container_id');
                var $container = $('#' + container_id);

                $trigger.on('click', function (e) {
                    e.preventDefault();

                    var $expand_indicator = $(this).children('span');

                    if ($expand_indicator.hasClass('expand')) {
                        $container.show();

                        $expand_indicator.removeClass('expand')
                            .addClass('contract');
                    } else {
                        $expand_indicator.addClass('expand')
                            .removeClass('contract');
                        $container.hide();
                    }
                });
            });

            $('a.expand_content').each(function (indexInArray, elem) {
                var parent = $(elem).parents('.expandable2');
                $(elem).on('click', function (e) {
                    e.preventDefault();
                    parent.toggleClass('expanded');
                });
            });
        }
    };

    UX.LazyLoad = {
        Init: function () {
            $('img.lazyload').each(function () {
                var img = $(this),
                    img_src = img.attr('data-src') || '';

                img.attr('src', img_src);
            });
        }
    };

    UX.JumptoSavedCity = function () {
        $('#discover_link').on('click', function (e) {
            if (User.id) {
                e.preventDefault();
                var last_city = Storage.Get('mapmy_local');
                if (last_city) {
                    window.location = last_city;
                } else {
                    window.location = '/us/';
                }
            }
        });
    };

    var modal_messager_types = {
        /**
         * Returns a promise (confirm = resolve, cancel = reject) if custom buttons
         * are not defined.
         * @param {Object} content
         * @param {Object} options
         * @param {String || Object} options.content String or DOM element
         * @param {Object} options.buttons [Optional] Confirm and Cancel buttons
         *
         * @return {Object} Promise
         */
        confirm: function (content, options) {
            return UX.ModalMessager.message(_.extend({
                content: content,
                title: 'Are you sure?',
                type: 'confirm',
                confirm: true
            }, options));
        },
        error: function (content, options) {
            return UX.ModalMessager.message(_.extend({
                content: content,
                title: 'Whoops, something went wrong.',
                type: 'error'
            }, options));
        },
        info: function (content, options) {
            return UX.ModalMessager.message(_.extend({
                content: content
            }, options));
        },
        success: function (content, options) {
            return UX.ModalMessager.message(_.extend({
                content: content,
                title: 'Success!',
                type: 'success'
            }, options));
        },
        warning: function (content, options) {
            return UX.ModalMessager.message(_.extend({
                content: content,
                type: 'warning'
            }, options));
        }
    };

    UX.ModalMessager = {
        /**
         * @param {Object} options
         * @param {String || Object} options.content
         * @param {String} options.type [Optional] Message type (see: modal_messager_types)
         * @param {Boolean} options.solo [Optional] [default: true] Force all other qtip objects to close?
         *
         * @return promise
         */
        message: function (options) {
            options = options || {};
            utils.assert(options.content, 'options.content is a required parameter');

            var classes = [
                'qtip-light',
                'largetip',
                modal_messager_types[options.type] ? options.type : '',
                options.classes ? ' ' + options.classes : ''
            ].join(' ');
            var context = {
                buttons: (function (buttons) {
                    if (typeof buttons === 'string') {
                        return new Handlebars.SafeString(buttons);
                    }
                    if (buttons === false) {
                        return false;
                    }
                    return true;
                }(options.buttons)),
                content: new Handlebars.SafeString(options.content),
                title: options.title,
                confirm: options.confirm
            };
            var deferred = $.Deferred();

            $('<div>').qtip({
                id: 'modal-messager',
                content: {
                    text: modalMessagerTmpl(context)
                },
                position: {
                    my: 'center', // ...at the center of the viewport
                    at: 'center',
                    target: $(window)
                },
                events: {
                    hide: function (event, api) {
                        api.destroy();
                    },
                    render: function (event, api) {
                        var $qtip = $(api.elements.tooltip);
                        var $this;

                        $qtip.on('click', '.actions .close', function (event) {
                            $this = $(event.target);

                            if ($this.hasClass('confirm')) {
                                deferred.resolve(event, api);
                            }
                            else if ($this.hasClass('cancel')) {
                                deferred.reject(event, api);
                            }
                            $qtip.qtip('hide');
                            return false;
                        });
                    }
                },
                show: {
                    event: false,
                    solo: options.solo || true,
                    modal: true,
                    ready: true
                },
                hide: {
                    event: false
                },
                style: {
                    classes: classes,
                    width: 600
                }
            });

            return deferred.promise();
        }
    };
    _.extend(UX.ModalMessager, modal_messager_types);

    /**
     * Slides down element, waits, slides up.
     *
     * @param {JQuery Object} element
     * @param {Object} options
     * @param {Number} options.delay ms before hide
     * @param {Function} options.show Function to execute after show
     * @param {Function} options.hide Function to execute after hide
     */
    UX.showThenHide = function (element, options) {
        var $el = $(element);
        options = _.extend({
            delay: 2000,
            hide: function () {},
            show: function () {}
        }, options);

        $el.slideDown(function () {
            options.show();
            _.delay(function () {
                $el.slideUp(function () {
                    options.hide();
                });
            }, options.delay);
        });
    };

    UX.NavJump = function (nav_menu_selector, section_container_selector) {
       this.nav_menu = $(nav_menu_selector);
       this.section_container = $(section_container_selector);

       this.nav_menu.find('a').on('click', $.proxy(function (e) {
           var target = e.target;
           e.preventDefault();
           window.location.hash = '#section/' + $(target).attr('href').replace('#', '');
           this.nav();
       }, this));
    };

    UX.NavJump.prototype.navJump = function (section) {
       var container = section,
           this_parent = this.navMenuItem(section);

       this.section_container.find('> section').hide();
       $('#' +  container).show();

       this.nav_menu.find('li').removeClass('active');
       this_parent.addClass('active');
    };

    UX.NavJump.prototype.nav = function () {
       if (window.location.hash && window.location.hash !== '#_=_') {
           var hash = this.currentSection();
           this.navJump(hash);
           this.onChange({isLast: this.isLast()});
       } else {
           this.nav_menu.find('a:first').trigger('click');
       }
    };

    UX.NavJump.prototype.onChange = function (info) {

    };

    UX.NavJump.prototype.currentSection = function () {
       return window.location.hash.substring(1).replace('section/', '');
    };

    UX.NavJump.prototype.isLast = function () {
       return this.nextNavMenuItem().length === 0;
    };

    UX.NavJump.prototype.navMenuItem = function (section) {
       return this.nav_menu.find('a[href="#' + section + '"]').parent('li');
    };

    UX.NavJump.prototype.nextNavMenuItem = function (elem) {
       if (!elem) {
           var current_section = this.currentSection();
           elem = this.navMenuItem(current_section);
       }
       return elem.next('li');
    };

    UX.NavJump.prototype.next = function () {
       var next_menu_item = this.nextNavMenuItem();
       if (next_menu_item) {
           next_menu_item.find('a').trigger('click');
       }
       return this.nextNavMenuItem(next_menu_item);
    };

    return UX;
});

